// eslint-disable-next-line import/prefer-default-export
import Vue from "vue";
export const notificationsMutations = {
    PUSH_NOTIFICATION: (state, notification) => {
        Vue.set(state.notifications, notification.key, notification)
    },
    HIDE_NOTIFICATION: (state, key) => {
        Vue.set(state.notifications[key], "hide", true)
    },
    REMOVE_NOTIFICATION: (state, key) => {
        Vue.delete(state.notifications, key)
    }
};
